import { PureComponent } from 'react';

interface Props {
    searchInput?: string;
    toggleAddPtModal: () => void;
}

class AddNewPatient extends PureComponent<Props> {
    render() {
        const { searchInput, toggleAddPtModal } = this.props;

        return (
            <div
                className="flex items-center space-x-8 cursor-pointer px-2 py-4"
                onClick={toggleAddPtModal}
            >
                <svg
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                >
                    <path d="M13.2812 7.625C13.2812 7.98047 13.002 8.23438 12.6719 8.23438H8.60938V12.2969C8.60938 12.6523 8.33008 12.9316 8 12.9316C7.64453 12.9316 7.39062 12.6523 7.39062 12.2969V8.23438H3.32812C2.97266 8.23438 2.71875 7.98047 2.71875 7.65039C2.71875 7.29492 2.97266 7.01562 3.32812 7.01562H7.39062V2.95312C7.39062 2.62305 7.64453 2.36914 8 2.36914C8.33008 2.36914 8.60938 2.62305 8.60938 2.95312V7.01562H12.6719C13.002 7.01562 13.2812 7.29492 13.2812 7.625Z" />
                </svg>
                <p className="font-700 text-darwin-accent-bright-blue-800">
                    Add New Patient {`${searchInput?.trim() ? `"${searchInput}"` : ''}`}
                </p>
            </div>
        );
    }
}

export default AddNewPatient;
